import React from 'react';
import Router from './components/Router/Router';

const App = () => <Router />;

export default App;
